import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { canManageKarkhana } from "../../helpers/karkhanaEnabled";
import "../gi-registry/gi-registry.scss";
import PageHeader from "./ui/PageHeader";
import SareeNumberSeries from "./sarees/SareeNumberSeries";
import "./rounds/karkhana-rounds.scss";
import { kp } from "./karkhanaPaths";

const readRole = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser") || "null")?.users?.role;
  } catch {
    return undefined;
  }
};

type Tile = { to: string; title: string; hint: string };

const GROUPS: { title: string; tiles: Tile[] }[] = [
  {
    title: "People",
    tiles: [
      { to: kp.workers(), title: "Workers", hint: "Weavers, helpers, dyers and their codes" },
      { to: kp.codes(), title: "Categories & codes", hint: "K_, J_, D_… and how new codes are made" },
      { to: kp.supervisors(), title: "Supervisors", hint: "Phone logins for the shop floor" },
    ],
  },
  {
    title: "Designs & pay rates",
    tiles: [
      { to: kp.parts(), title: "Saree parts", hint: "S_1, S_3 anchal… the work types on a rate card" },
      { to: kp.designs(), title: "Designs", hint: "Design numbers woven here" },
      { to: kp.rateCards(), title: "Rate cards", hint: "Per-inch rates, incentive and alone allowance" },
      { to: kp.timeRates(), title: "Time rates", hint: "Hourly or daily pay for helpers, dyeing, warping" },
    ],
  },
  {
    title: "Costing",
    tiles: [
      { to: kp.costingLines(), title: "Costing lines & material rates", hint: "Line names, starting %s, silk and zari prices" },
    ],
  },
  {
    title: "Import",
    tiles: [
      { to: kp.import(), title: "Import", hint: "Any sheet: people, looms, rates, sarees on looms, advances, old daily work" },
      { to: kp.rateImport(), title: "Import designs and rates", hint: "One CSV for designs and their rates" },
      { to: kp.oldSheet(), title: "Import the old sheet", hint: "DAILY WORK history, read-only" },
    ],
  },
];

/** Karkhana setup in one place, so the daily screens stay about the day's work. */
const KarkhanaSettingsPage = () => {
  const history = useHistory();
  const role = readRole();

  useEffect(() => {
    if (!canManageKarkhana(role)) history.replace(kp.home());
  }, [role, history]);

  if (!canManageKarkhana(role)) return null;

  return (
    <div className="gi-registry-page kw-page">
      <PageHeader title="Karkhana settings" back={kp.home()} />
      <div className="kh-settings">
        {GROUPS.map((g) => (
          <section key={g.title} className="kh-settings__group">
            <h3>{g.title}</h3>
            <div className="kh-tiles">
              {g.tiles.map((tile) => (
                <Link key={tile.to} to={tile.to} className="kh-tile">
                  <strong>{tile.title}</strong>
                  <span>{tile.hint}</span>
                </Link>
              ))}
            </div>
          </section>
        ))}
        <SareeNumberSeries />
      </div>
    </div>
  );
};

export default KarkhanaSettingsPage;
